import { prompt } from '@kuaizhan/kui'; // import { fakeMsgList } from './data';

var fetchMsgListSuccess = function fetchMsgListSuccess(data) {
  var msgList = data.msgList.map(function (item) {
    var _id = item._id,
        is_clicked = item.is_clicked,
        is_important = item.is_important,
        title = item.title,
        url = item.url,
        content = item.content;
    return {
      id: _id && _id.$id || '',
      isClicked: is_clicked,
      isImportant: is_important,
      title: title,
      url: url,
      content: content
    };
  });
  return {
    type: 'header.fetchMsgListSuccess',
    msgList: msgList
  };
};

export var fetchMsgList = function fetchMsgList(ds) {
  return function (dispatch) {
    ds.resolve('v1/passport.getNotices').then(function (res) {
      if (res.body.ret === 0) {
        dispatch(fetchMsgListSuccess({
          msgList: res.body.data && res.body.data.list // msgList: fakeMsgList,

        }));
      } else {
        prompt.alert(res.body.msg);
      }
    }).catch(function (err) {
      // 这个接口经常超时, 又不是特别重要
      // prompt.alert(err.toString());
      console.log(err.toString());
    });
  };
};

var readAllSuccess = function readAllSuccess() {
  return {
    type: 'header.readAllSuccess'
  };
};

export var readAll = function readAll(ds) {
  return function (dispatch) {
    ds.resolve('v1/passport.setNoticesRead', {
      body: {
        mode: 'all'
      }
    }).then(function (res) {
      if (res.body.ret === 0) {
        dispatch(readAllSuccess());
      } else {// prompt.alert(res.body.msg);
      }
    }).catch(function (err) {
      prompt.alert(err.toString());
    });
  };
};

var readMsgSuccess = function readMsgSuccess() {
  return {
    type: 'header.readMsgSuccess'
  };
};

export var readMsg = function readMsg(ds, opt) {
  return function (dispatch) {
    ds.resolve('v1/passport.setNoticesRead', {
      body: {
        notice_id: opt.msgId
      }
    }).then(function (res) {
      if (res.body.ret === 0) {
        dispatch(readMsgSuccess());
      } else {// prompt.alert(res.body.msg);
      }
    }).catch(function (err) {
      prompt.alert(err.toString());
    });
  };
};